export const StoreId = {
  Byrider: 102,
  ChernerBrothers: 106,
  ClevelandMaserati: 91,
  ClevelandMotorsports: 90,
  DestinationBurnaby: 59,
  Drivably: 7,
  iDriveCertified: 171,
  InfinitiMonrovia: 163,
  LeeCarsAugusta: 157,
  LeeCarsNorway: 158,
  LeeCarsSaco: 159,
  LeeChryslerJeepDodgeRamAuburn: 145,
  LeeCreditExpressAuburn: 155,
  LeeCreditNowBangorHammondSt: 150,
  LeeCreditNowBangorHoganRd: 151,
  LeeCreditNowBrewer: 152,
  LeeCreditNowEllsworth: 153,
  LeeCreditNowNewport: 156,
  LeeCreditNowOakland: 154,
  LeeDodgeChryslerJeepRamWestbrook: 149,
  LeeGMCAuburn: 146,
  LeeHondaAuburn: 147,
  LeeNissanAuburn: 148,
  LeeNissanofTopsham: 143,
  LeeToyotaTopsham: 144,
  NissanBuenaPark: 162,
  NissanDelRay: 170,
  NissanKendall: 8,
  NissanPuenteHills: 164,
  WindyCityMotors: 189,
  WindyCityBMW: 190,
};

export const getStoreMetadataById = (id) => {
  switch (id) {
    case StoreId.Byrider:
      return { logoSrc: '/image/logo-byrider.svg' };
    case StoreId.ChernerBrothers:
      return { logoSrc: '/image/logo-cherner-brothers.png' };
    case StoreId.ClevelandMaserati:
      return { logoSrc: '/image/logo-cleveland-maserati.png' };
    case StoreId.ClevelandMotorsports:
      return { logoSrc: '/image/logo-cleveland-motorsports.png' };
    case StoreId.iDriveCertified:
      return { logoSrc: '/image/logo-idrive-certified.png' };
    case StoreId.InfinitiMonrovia:
      return { logoSrc: '/image/logo-infiniti-monrovia.png' };
    case StoreId.LeeCreditExpressAuburn:
      return { logoSrc: '/image/logo-lee-credit-express.webp' };
    case StoreId.LeeCarsAugusta:
    case StoreId.LeeCarsNorway:
    case StoreId.LeeCarsSaco:
    case StoreId.LeeChryslerJeepDodgeRamAuburn:
    case StoreId.LeeCreditNowBangorHammondSt:
    case StoreId.LeeCreditNowBangorHoganRd:
    case StoreId.LeeCreditNowBrewer:
    case StoreId.LeeCreditNowEllsworth:
    case StoreId.LeeCreditNowNewport:
    case StoreId.LeeCreditNowOakland:
    case StoreId.LeeDodgeChryslerJeepRamWestbrook:
    case StoreId.LeeGMCAuburn:
    case StoreId.LeeNissanofTopsham:
      return { logoSrc: '/image/logo-lee-auto.png' };
    case StoreId.LeeHondaAuburn:
      return { logoSrc: '/image/logo-lee-honda-auburn.png' };
    case StoreId.LeeNissanAuburn:
      return { logoSrc: '/image/logo-lee-nissan-auburn.png' };
    case StoreId.LeeToyotaTopsham:
      return { logoSrc: '/image/logo-lee-toyota-topsham.webp' };
    case StoreId.NissanBuenaPark:
      return { logoSrc: '/image/logo-nissan-buena-park.png' };
    case StoreId.NissanDelRay:
      return { logoSrc: '/image/logo-nissan-del-ray.png' };
    case StoreId.NissanKendall:
      return { logoSrc: '/image/logo-nissan-kendall.png' };
    case StoreId.NissanPuenteHills:
      return { logoSrc: '/image/logo-nissan-puente-hills.png' };
    case StoreId.WindyCityMotors:
      return { logoSrc: '/image/logo-windy-city-demo.png' };
    case StoreId.WindyCityBMW:
      return { logoSrc: '/image/logo-windy-city.png' };
    // TODO cannot retrieve burnaby logo, site returns 403
    case StoreId.DestinationBurnaby:
    case StoreId.Drivably:
    default:
      return { logoSrc: '/image/logo-drivably.svg' };
  }
};
// Default offer dealer text used by all stores
export const DEFAULT_OFFER_DEALER_TEXT = 'Price pending dealer inspection and validation of stated condition';

// Store IDs that use the default offer dealer text
export const STORE_IDS_WITH_OFFER_TEXT = [
  193, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213,
  217, 218, 220, 221, 222, 223, 225, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239,
  240, 241, 242, 243, 244, 245, 247, 248, 249, 251, 252, 253, 255, 256, 257, 258, 259, 260, 261, 262,
  263, 264, 265, 266, 267, 268, 269, 271, 272, 273, 274, 275, 276, 277, 278, 279, 281, 282, 283, 284,
  285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 297, 298, 299, 300, 301, 302, 303, 304, 305,
  306, 307, 308, 309, 310, 311, 312, 314, 315, 316, 317, 318, 319, 320, 322, 323, 324, 325, 326, 327,
  328, 329, 331, 332, 333, 334, 335, 337, 338, 339, 341, 342, 343, 344, 345, 346, 474, 728, 729, 731,
  815, 916, 976
];
